import * as React from 'react';
import { createComponent } from '@lit/react';
import { UniversalUserDropdownTriggerWC } from './universal-user-dropdown-trigger.wc';

export const UniversalUserDropdownTrigger = createComponent({
  tagName: UniversalUserDropdownTriggerWC.tagname,
  elementClass: UniversalUserDropdownTriggerWC,
  react: React,
});
